import api from "../../index.js";
import { qs } from "../../../utils/utils.js";

export const KycManager = (params) => api.get(`admin/getallkyc?${qs(params)}`);
export const KycRequestAcceptRejectApi = (data) => api.post('admin/kycrejectedapproved', data);
export const GetAllKycByIdApi = (userId) => api.get(`admin/getsinglekyc/${userId}`);
